module.exports = __webpack_public_path__ + "static/media/privacypolicy.68aff2d8.htm";